import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import Constants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import toast from "react-hot-toast";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/human_resource_appCommonService";
import { getReceiptsList, receiptNr } from "../../../../redux/feature/hr_app/hrSlice";
import UploadModal from "../../../profit_ledger_app/Profit_ledger/Common/UploadModal";
import UploadDataViewModal from "../../../profit_ledger_app/Profit_ledger/Common/UploadDataViewModal";
import StatisticsContainer from "../../../../Components/Cards/StatisticsCardContainer";
import { getModuleStats } from "../../../../redux/feature/warehouse_app/warehouseSlice";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import CancelModal from "../../../../Components/CancleModal/CancelModal";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import ExpensesDetails from "./ReceiptsDetails";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import ReceiptsModel from "../../Finance/Receipts/ReceiptsModal"
const ReceiptsList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Finance");
  localStorage.setItem("submenu", "Expenses");
  let cashDataTable = useSelector(
    (state) => state?.hr?.receipts?.pagination,
  );
  let cashData = useSelector((state) => state?.hr?.receipts);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const [showDataModal, setShowDataModal] = useState(false);
  const [receiptsModal, setReceiptsModal] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [actionType, setActionType] = useState("Cancel");
  const [singleCancelRow, setSingleCancelRow] = useState(null);
  const [showStats, setShowStats] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalUpdate, setModalUpdate] = useState(false);
  const moduleStats = useSelector((state) => state.warehouse.moduleStats.data);
  const statsPayload = {
    dashboard: "hr_module",
    chartFilterType: "Yearly",
    chartInput2: new Date().getFullYear(),
  };
  const showUpdateModal = () => {
    setModalUpdate(true);
  };
  const hideUpdateModal = () => {
    setModalUpdate(false);
  };
  const handleEditClick = (row) => {
    dispatch(receiptNr(row));
    showUpdateModal("EDIT", row.documentNumber);
  };

  const DEFAULT_LIST_PARAMS = {
    queryName: "Get_HRFinanceRCP_List",
    module: "",
    page: 1,
    per_page: 10,
  };

  const refreshWarehousePage = () => {
    dispatch(getReceiptsList(DEFAULT_LIST_PARAMS));
    dispatch(getModuleStats(statsPayload));
  };
  useEffect(() => {
    refreshWarehousePage();
    // eslint-disable-next-line
  }, [dispatch]);

  const handleUploadComplete = async ({ jsonData, file }) => {
    const enrichedData = await Promise.all(
      jsonData.map(async (row) => {
        let customerName = "";
        try {
          const obj1 = {
            queryName: "Get_HRFinanceRCP_List",
            documentNumber: row.customerCode,
          };
          const custRes = await ItemServiceV2.generateCustomerQuery(obj1);
          if (custRes?.status === 200 && custRes?.data?.length > 0) {
            customerName = custRes.data[0].organisationName;
          }
        } catch (err) {
          console.error("Error fetching customer name", err);
        }

        let companyName = "";
        try {
          const obj2 = {
            queryName: "Get_HRFinanceRCP_List",
            companyCode: row.companyCode,
          };
          const compRes = await ItemServiceV2.generateCustomerQuery(obj2);
          if (compRes?.status === 200 && compRes?.data?.length > 0) {
            companyName = compRes.data[0].companyCodeDesc;
          }
        } catch (err) {
          console.error("Error fetching company name", err);
        }

        return {
          ...row,
          customerCodeDesc: customerName,
          companyCodeDesc: companyName,
        };
      }),
    );

    setParsedData(enrichedData);
    setUploadedFile(file);
    setShowDataModal(true);
  };
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  let cumulative = 0;
  const parseAmount = (value) => {
    if (!value) return 0;
    return (
      parseFloat(
        value
          .toString()
          .replace(/[,\r\n]/g, "")
          .trim(),
      ) || 0
    );
  };

  // eslint-disable-next-line
  const enhancedData = data.flatMap((row) => {
    if (!Array.isArray(row.items)) return [];

    return row.items.map((item) => {
      const credit = parseAmount(item.creditAmount || item.poTotalNetValue);
      const debit = parseAmount(item.debitAmount || item.withdrawDebit);
      const net = credit - debit;

      cumulative += net;

      return {
        ...row,
        ...item,
        cumulative,
      };
    });
  });
  const handleSave = async () => {
    const allPayloads = [];

    parsedData.forEach((item) => {
      const debit = parseFloat(item.debitAmount || 0); // amount to pay
      const originalPayload = {
        data: {
          companyCode: item.companyCode,
          companyCode2: item.companyCode,
          companyCodeDesc: item.companyCodeDesc,
          customerCodeDesc: item.customerCodeDesc,
          transaction: "Payment",
          transactionType: "EK",
          customerCode: "",
          bankName: item.companyBankName,
          customerBank: item.customerBank,
          companyBank: item.companyBank,
          transactionMode: item.transactionMode,
          bankTransactionDate: item.bankTransactionDate,
          partyCode: item.partyCode,
          remarks: item.remarks,
          type: "CREDIT", // company credited
          expensesHead: item.expensesHead,
          items: [
            {
              slNo: "1",
              creditAmount: debit, // company credited
              debitAmount: 0,
              transaction: "Payment",
            },
          ],
          documentNumber: item.documentNumber,
          invoiceNr: item.invoiceNr,
          invoiceStatusHeader: item.invoiceStatusHeader,
          createdBy: item.createdBy,
          createdByName: item.createdByName,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        },
      };

      // Reverse payload: driver debited
      const reversePayload = {
        data: {
          companyCode: "",
          companyCode2: item.companyCode,
          companyCodeDesc: item.companyCodeDesc,
          customerCodeDesc: item.customerCodeDesc,
          transaction: "Receipt",
          transactionType: "EK",
          customerCode: item.customerCode,
          bankName: item.customerBankName,
          customerBank: item.customerBank,
          companyBank: item.companyBank,
          transactionMode: item.transactionMode,
          bankTransactionDate: item.bankTransactionDate,
          partyCode: item.partyCode,
          remarks: item.remarks,
          type: "DEBIT", // driver debited
          expensesHead: item.expensesHead,
          items: [
            {
              slNo: "1",
              creditAmount: 0,
              debitAmount: debit, // driver receives
              transaction: "Receipt",
            },
          ],
          documentNumber: item.documentNumber,
          invoiceNr: item.documentNumber,
          invoiceStatusHeader: item.invoiceStatusHeader,
          createdBy: item.createdBy,
          createdByName: item.createdByName,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        },
      };

      allPayloads.push(originalPayload, reversePayload);
    });

    // send payloads to API
    setDisabled(true);
    setLoading(true);
    const failedEntries = [];

    try {
      for (const payload of allPayloads) {
        const response = await ItemServiceV2.addInvoice(payload);
        if (!response || response.status !== 200) {
          failedEntries.push(
            payload.data.companyCodeDesc || payload.data.companyCode,
          );
        }
      }
      if (failedEntries.length === 0) {
        toast.success("Salary paid successfully", {
          duration: 3000,
          position: "top-right",
        });
        dispatch(
          getReceiptsList({
            queryName: "Get_HRFinanceRCP_List",
          }),
        );
        setShowDataModal(false);
      } else {
        toast.error(`Failed for: ${failedEntries.join(", ")}`, {
          duration: 5000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong during salary payment", {
        duration: 5000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
      setLoading(false);
    }
  };
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = (row = null, type = "Cancel") => {
    setActionType(type);
    if (row) {
      setSingleCancelRow(row);
    } else {
      setSingleCancelRow(null);
    }
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
    setSingleCancelRow(null);
    setActionType("Cancel");
  };
  const cancelRows = singleCancelRow ? [singleCancelRow] : selectedRows;
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) =>
        item?.statusHeader !== "Cancelled" && item?.statusHeader !== "Deleted",
    );
    setSelectedRows(validRows);
    setSelectedRowIds(validRows.map((item) => String(item.stockNr)));
  };
  const handleCancelAPI = async (modalPayload = {}) => {
    try {
      const rows = singleCancelRow ? [singleCancelRow] : selectedRows;
      const payload = {
        documentNumber: rows.map((item) => item.expenseNr),
        actionType,
        cancellationRemark: modalPayload?.cancellationRemark || "",
      };
      const res = await ItemService.cancelOrDeleteExpense(payload);
      if (res?.status === 200) {
        toast.success(res?.message || `${actionType} successful`, {
          duration: 3000,
          position: "top-right",
        });
        refreshWarehousePage();
        return res;
      } else {
        toast.error(res?.message || `${actionType} failed. Please try again!`, {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error(`${actionType} API Error:`, err);
      toast.error(err?.response?.data?.message || "Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
      return null;
    }
  };
  const CashUploadColumns = [
    {
      name: "Company",
      id: "companyCode",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <div>
          <p className="">{row.companyCodeDesc || "--"}</p>
          {row.companyCode || "--"}
          <p></p>
        </div>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Company Bank",
      selector: (row) => row.companyBankName,
      sortable: true,
      width: "140px",
    },

    {
      name: "Customer",
      cell: (row) => (
        <div className="d-flex flex-column">
          <p className="m-0 fw-bold"> {row.customerName} </p>
          <p className="m-0"> {row.customerCodeDesc} </p>
        </div>
      ),
      width: "160px",
    },

    {
      name: "Customer Bank",
      selector: (row) => row.customerBankName,
      sortable: true,
      width: "140px",
    },
    {
      name: "Expenses",
      selector: (row) => row.expensesHead,
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction Mode",
      selector: (row) => row.transactionMode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Date",
      selector: (row) => row.bankTransactionDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Type",
      selector: (row) => row.type,
      sortable: true,
      width: "180px",
      cell: (row) => {
        const parseAmount = (val) =>
          parseFloat((val || "0").toString().replace(/,/g, ""));

        const credit = parseAmount(row.creditAmount);
        const debit = parseAmount(row.debitAmount);

        let displayType = "Invalid";
        // let badgeClass = "bg-table-status bg-table-warning-status";

        if (credit > 0 && debit === 0) {
          displayType = "Credit";
          // badgeClass = "bg-table-status bg-table-success-status";
        } else if (debit > 0 && credit === 0) {
          displayType = "Debit";
          // badgeClass = "bg-table-status bg-table-danger-status";
        }
        return <span>{displayType}</span>;
      },
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      sortable: true,
      width: "180px",
    },
    {
      name: "Debit",
      selector: (row) => row.debitAmount,
      sortable: true,
      width: "150px",
      // right: true,
    },
    {
      name: "Credit",
      selector: (row) => row.creditAmount,
      sortable: true,
      width: "150px",
      // right: true,
    },
  ];
  const cashRow = [
    {
      name: "Receipts Nr",
      id: "expenseNr",
      cell: (row) => {
        const docNo = row.expenseNr || row.draftNr;
        return (
          <button
            className="btnInfo"
            onClick={() => handleEditClick(docNo, row)}
          >
            {docNo}
          </button>
        );
      },
      width: "150px",
    },
    {
      name: "Receiptes",
      selector: (row) => row.receiptName,
      sortable: true,
      width: "140px",
    },
    {
      name: "Amount",
      selector: (row) => row.receiptAmount,
      sortable: true,
      width: "140px",
    },
    {
      name: "Status",
      selector: (row) => row.headerStatus,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.headerStatus} />
        </>
      ),
      width: "200px",
    },
    {
      name: "Receiver Name",
      id: "receiptReceiverName",
      selector: (row) => row.receiptReceiverName,
      cell: (row) => (
        <div>
          <p className="fw-bold">{row.receiptReceiverName || "--"}</p>
          {/* {row.expenseReceiverName || "--"} */}
          <p></p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode,
      cell: (row) => <p className="fw-bold text-primary">{row.paymentMode}</p>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Mode",
      selector: (row) => row.transactionMode,
      cell: (row) => <p className="fw-bold">{row.transactionMode}</p>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Date",
      selector: (row) => row.bankTransactionDate,
      sortable: true,
      width: "180px",
    },
    {
      name: "Remarks",
      selector: (row) => row.paymentPurpose,
      cell: (row) => <p>{row.paymentPurpose}</p>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Action",
      cell: (row) => {
        const status = row?.headerStatus;
        const isCancelled = status === "Cancelled";
        const isDeleted = status === "Deleted";
        return (
          <TableActions
            selectedRow={selectedRowIds.includes(String(row.expenseNr))}
            actions={[
              {
                key: "details",
                label: "Details",
                icon: "bi bi-info-circle",
              },
              {
                key: "edit",
                label: "Edit",
                icon: "bi bi-pencil-square",
                onClick: () => handleEditClick(row.expenseNr),
                disabled: isDeleted,
              },
              {
                key: "cancel",
                label: "Cancel",
                icon: "bi bi-x-circle",
                onClick: () => cancelModalShow(row, "Cancel"),
                selectRow: true,
                disabled: isCancelled || isDeleted,
              },
              {
                key: "delete",
                label: "Delete",
                icon: "bi bi-trash",
                onClick: () => cancelModalShow(row, "Delete"),
                selectRow: true,
                disabled: isDeleted,
              },
              {
                key: "more",
                label: "More",
                icon: "bi bi-three-dots",
                onClick: () => console.log("More", row),
              },
            ]}
          />
        );
      },
      width: "180px",
    },
  ];
  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_HRFinanceRCP_List",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getReceiptsList(obj));
    setData(cashData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_HRFinanceRCP_List",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getReceiptsList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_HRFinanceRCP_List",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getReceiptsList(obj));
    setData(cashData?.data);
  };

  const loadInitialPOData = async () => {
    setData(cashData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_HRFinanceRCP_List",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getReceiptsList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showReceiptsModal = () => {
    setReceiptsModal(true);
  };
  const hideModalStatus = () => {
    setReceiptsModal(false); //hide cash request modal
  };
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_HRFinanceRCP_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getReceiptsList(obj));
  };

  const columnsForFilter = cashRow
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Receipts</h2>
                <p className="subText">Lists of Receipts and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                // fetchFunction={ItemService.getEmployeeList} // Replace with your actual fetch function
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>
                <StatisticsContainer
                  statsMode="redux"
                  reduxStats={moduleStats}
                  reduxKey="receipts"
                  keyName="headerStatus"
                  paginatedList={cashData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">R</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Receipts</span>
                      <span className="subHeaderTitle">
                        View of Receipts and Status{" "}
                      </span>
                    </Col>
                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => showReceiptsModal()}
                        >
                          Receipts
                        </button>
                      </Col>
                      <Col xs={6} md={6} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => setShowUploadModal(true)}
                        >
                          Receipts Upload
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <StickyColumn columnIndexes={[1]} leftOffsets={[0]} />
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={cashRow}
                          data={filteredData}
                          progressPending={cashData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={cashDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRowss
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <UploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
      <UploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={CashUploadColumns}
        title="Uploaded Cash Expenses"
        file={uploadedFile}
        onClick={handleSave}
        disabled={disabled}
        loading={loading}
      />
      {/* <ExpensesModel show={receiptsModal} onHide={() => hideModalStatus()} /> */}
      <ReceiptsModel
        show={receiptsModal}
        onHide={() => hideModalStatus()}
        onSuccess={() => {
          hideModalStatus();
          dispatch(
            getReceiptsList({
              queryName: "Get_HRFinanceRCP_List",
              page: 1,
              per_page: 10,
            }),
          );
        }}
      />
      <ExpensesDetails
        show={modalUpdate}
        onHide={hideUpdateModal}
        onSuccess={() => {
          hideUpdateModal();

          dispatch(
            getReceiptsList({
              queryName: "Get_HRFinanceRCP_List",
              page: 1,
              per_page: 10,
            }),
          );
        }}
      />
      <CancelModal
        title={
          actionType === "Delete"
            ? "Delete the Expenses"
            : "Cancel the Expenses"
        }
        type="Expenses"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={cancelRows}
        onConfirm={handleCancelAPI}
        docKey="expenseNr"
        onSuccess={() => {
          setSelectedRows([]);
          setSelectedRowIds([]);
          setSingleCancelRow(null);
          setActionType("Cancel");
          refreshWarehousePage();
        }}
      />
    </main>
  );
};

export default ReceiptsList;
